export const getElements = state => state.elements
